export default __webpack_public_path__ + "static/media/brain-bg-icon.5fb85df1.svg";